import Entity from "./entity";
export default class MembershipDemand extends Entity<number> {
  courtId: number;
  price: number;
  linkMan: string;
  membershipCategory: string;
  demandType: number;
  phoneNumber: string;
  isPublish: boolean;
  remark: string;
}
